import { Construction } from 'lucide-react';

interface PlaceholderProps {
  title: string;
  description: string;
}

/**
 * Placeholder page for features not yet implemented.
 */
export function Placeholder({ title, description }: PlaceholderProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <Construction className="h-12 w-12 text-foreground-muted mb-4" />
      <h3 className="text-lg font-medium">{title}</h3>
      <p className="text-sm text-foreground-muted mt-1 max-w-md">{description}</p>
      <span className="mt-4 text-xs text-foreground-subtle">Coming in Phase 2</span>
    </div>
  );
}
